import * as types from "../../ActionType";

const initState = {
    sub_categories: [],
    loadingSubCategories: true
}

const SubcategoryReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_SUB_CATEGORY:
            return { ...state, loadingSubCategories: true }
        case types.GET_SUB_CATEGORIES:
            return { ...state, sub_categories: action.payload, loadingSubCategories: false }
        
        case types.DELETE_SUB_CATEGORY:
            return { ...state }
        case types.EDIT_SUB_CATEGORY:
            return { ...state, loadingSubCategories: true }
        default:
            return state;
    }
};

export default SubcategoryReducer;
